export default __webpack_public_path__ + "static/media/91XAS7_notice_241022_v2.0966e3f5.pdf";